export enum ContactType {
  PHONE_NUMBER = 'PHONE_NUMBER',
  EMAIL = 'EMAIL',
  INSTAGRAM = 'INSTAGRAM',
  FACEBOOK = 'FACEBOOK',
  TELEGRAM = 'TELEGRAM',
  LINKTREE = 'LINKTREE',
  WEBSITE = 'WEBSITE',
}

export interface Contact {
  type: ContactType;
  value: string;
  visible: boolean;
  comment?: string | null;
}
